import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as $ from "jquery";
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// функция `startYandexMetricaCode` находится в html файле
declare function startYandexMetricaCode(): void;

if (environment.production) {
  if (typeof startYandexMetricaCode === 'function') startYandexMetricaCode();
}

enableProdMode();

platformBrowserDynamic().bootstrapModule(AppModule,{
  //enableLegacyTemplate:false
});